import React, { useState, useEffect } from 'react';
import axios from 'axios';
import MainChart from './MainChart';

const EfectorChart = ({ selectedDelegacion }) => {
  const [rawData, setRawData] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [decisionChartData, setDecisionChartData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // null = sin filtro (todas las decisiones visibles). Se completa al tocar
  // el legend del gráfico de Decisión IA, con las series que quedaron visibles.
  const [visibleDecisions, setVisibleDecisions] = useState(null);

  useEffect(() => {
    const fetchEfectoresData = async () => {
      try {
        const response = await axios.get('/api/efectores');
        setRawData(response.data);
      } catch (err) {
        console.error('Error fetching efectores data:', err);
        setError('Error al cargar los datos de efectores.');
      } finally {
        setLoading(false);
      }
    };

    fetchEfectoresData();
  }, []);

  useEffect(() => {
    let filtered = rawData.map(item => ({
      fecha: item.fecha,
      indicador: item.efector,
      valor: 1,
      delegacion: item.delegacion,
      decision: item.decision,
    }));

    let decisionFiltered = rawData.map(item => ({
      fecha: item.fecha,
      indicador: item.decision,
      valor: 1,
      delegacion: item.delegacion,
    }));

    if (selectedDelegacion && selectedDelegacion !== 'Todas') {
      filtered = filtered.filter(item => item.delegacion === selectedDelegacion);
      decisionFiltered = decisionFiltered.filter(item => item.delegacion === selectedDelegacion);
    }

    if (visibleDecisions) {
      filtered = filtered.filter(item => visibleDecisions.includes(item.decision));
    }

    setChartData(filtered);
    setDecisionChartData(decisionFiltered);
  }, [rawData, selectedDelegacion, visibleDecisions]);

  if (loading) {
    return <div className="text-center">Cargando datos de efectores...</div>;
  }

  if (error) {
    return <div className="text-center text-danger">{error}</div>;
  }

  return (
    <>
      <MainChart data={chartData} title="Coincidencia de Efector por Fecha" />
      <div className="mt-3">
        <MainChart
          data={decisionChartData}
          title="Decisión IA sobre Efector por Fecha"
          onVisibleLabelsChange={setVisibleDecisions}
        />
      </div>
    </>
  );
};

export default EfectorChart;
